var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 100,
    viewBox: "0 0 500 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 10,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 10 20)"
  }, "%")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 20,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 90 40)"
  }, "%")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 25,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 170 60)"
  }, "%")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 30,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 250 80)"
  }, "%")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 40,
    fontFamily: "Arial",
    fontSize: 18,
    fill: "white",
    transform: "rotate(10 330 100)"
  }, "%")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 50,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 410 120)"
  }, "%")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 60,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 70,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 80,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    transform: "rotate(10 490 140)"
  }, "%")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.1d02d2db5a908187394a18ed72412f57.svg";
export { ForwardRef as ReactComponent };